export default function CtaBand() {
  return (
    <section className="relative w-full overflow-hidden bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg border border-background-200 bg-foreground-950 px-6 py-12 md:px-12 md:py-16">
          <div className="absolute inset-0 opacity-40">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20warm%20amber%20light%20streaks%20over%20dark%20charcoal%20gradient%20background%2C%20minimal%20cinematic%20visual%2C%20soft%20glow%2C%20no%20text&width=1600&height=700&seq=baoliao-cta-01&orientation=landscape"
              alt=""
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="relative flex flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
            <div className="max-w-xl">
              <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">先核对入口，再放心访问</h2>
              <p className="mt-4 text-sm leading-relaxed text-background-200">
                把主入口保存为书签，再用核对清单确认地址无误。遇到打不开的情况，按备用线路依次尝试即可。
              </p>
            </div>
            <div className="flex w-full flex-col gap-3 sm:flex-row md:w-auto">
              <a
                href="#address"
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
              >
                <i className="ri-list-check-2 text-base" aria-hidden="true" />
                核对最新地址
              </a>
              <a
                href="#faq"
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
              >
                <i className="ri-question-line text-base" aria-hidden="true" />
                查看常见问题
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}